import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(400px, 80vw), 1fr));
  grid-gap: 20px;
`;
